import React, { useState, useEffect } from "react";
import { Box, Tabs, Tab } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import DashboardLayout from "../../layouts/DashboardLayout";
import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";

import TenantTab from "./Tabs/TenantTab";
import PropertyTab from "./Tabs/PropertyTab";
import ArtisanTab from "./Tabs/ArtisanTab";

const TabPanel = ({ children, value, index, ...other }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`simple-tabpanel-${index}`}
    aria-labelledby={`simple-tab-${index}`}
    {...other}
  >
    {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
  </div>
);

const Asset_OverviewPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [tabValue, setTabValue] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tabParam = params.get("tab");
    const searchParam = params.get("search");

    if (tabParam) {
      if (tabParam === "tenants") setTabValue(0);
      else if (tabParam === "properties") setTabValue(1);
      else if (tabParam === "artisans") setTabValue(2);
    }

    if (searchParam) {
      setSearchQuery(searchParam);
    }
  }, [location.search]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    // Update URL when tab changes, clearing search
    const tabName =
      newValue === 0 ? "tenants" : newValue === 1 ? "properties" : "artisans";
    navigate(`/asset-overview?tab=${tabName}`);
    setSearchQuery(""); // Clear search when switching tabs
  };

  return (
    <DashboardLayout>
      <MDBox>
        <MDTypography variant="h4" fontWeight="medium" color="dark" mb={3}>
          Vermögensübersicht & Kontakte
        </MDTypography>

        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs value={tabValue} onChange={handleTabChange}>
            <Tab label="Mieter" />
            <Tab label="Immobilien" />
            <Tab label="Handwerker" />
          </Tabs>
        </Box>
        {/* Mieter Tab */}
        <TabPanel value={tabValue} index={0}>
          <TenantTab initialSearch={tabValue === 0 ? searchQuery : ""} />
        </TabPanel>
        {/* Immobilien Tab */}
        <TabPanel value={tabValue} index={1}>
          <PropertyTab initialSearch={tabValue === 1 ? searchQuery : ""} />
        </TabPanel>
        {/* Handwerker Tab */}
        <TabPanel value={tabValue} index={2}>
          <ArtisanTab initialSearch={tabValue === 2 ? searchQuery : ""} />
        </TabPanel>
      </MDBox>
    </DashboardLayout>
  );
};

export default Asset_OverviewPage;
